import { AppState } from '../../init/rootReducer';
import { initialProductState, makeQueryKey, ProductPageState } from './reducer';
import { ProductState } from './types';

export const getProductPageState = (state: AppState): ProductPageState => state.containers.product;

export const getProductState = (state: AppState, productId: number): ProductState =>
  getProductPageState(state).products[makeQueryKey(productId)] || initialProductState;
